/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
import { Controller, FieldErrors, UseFormRegister } from "react-hook-form";
import { useEffect, useState } from "react";
import {
  useDistrictFetchData,
  useFetchCountriesAllData,
  useFetchCountryCitiesAllData,
} from "../../apis/locationApis";
import { getFileExtension } from "../../utilities/helper";
import NewinputField from "../../components/NewInput";
import NewSelectInput from "../../components/NewSelectInput";
import { useFetchDriverTimeSlotAllData } from "../../apis/timeSlotApis";

export const SystemTypes = [
  { value: "phone", text: "Phone" },
  { value: "email", text: "Email" },
  { value: "whatsapp", text: "WhatsApp" },
];

// const DRIVER_ASSIGNMENT_MODE = [
//   { id: 1, value: "SHARED", text: "SHARED" },
//   { id: 2, value: "DEDICATED", text: "DEDICATED" },
//   { id: 3, value: "BRANCH SPECIFIC", text: "BRANCH SPECIFIC" },
// ];

type FormValues = {
  storeName: string;
  mobileNo: string;
  email: string;
  licenseNumber: string;
  licenseExpiry: string;
  countryId: string;
  cityId: string;
  image: string;
  document: string;
  status?: string;
  districtId: string;
  warehouseId: string;
  address?: string;
  supervisorId?: string;
  startDate?: string;
  iqamaNumber?: string;
  iqamaDoc?: File | undefined;
  vehicleId?: string;
  driverType?: string;
  driverCode?: string;
  pinCode: string;
  latitude: string;
  longitude: string;
  shortAddress: string;
  fullAddress: string;
  contactPerson?: string;
};

type Props = {
  register: UseFormRegister<FormValues>;
  errors: FieldErrors<FormValues>;
  clearErrors?: any;
  setValue?: any;
  getIds?: any;
  watch?: any;
  control?: any;
  darkStoreData?: any;
  setSelectedDocument?: any;
  parentId?: any;
};

const AddDarkStoreModal = ({
  register,
  errors,
  clearErrors,
  setValue,
  getIds,
  watch,
  control,
  darkStoreData,
  setSelectedDocument,
  parentId,
}: Props) => {
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<any>(
    watch("timeSlotId") || "",
  );
  const [createLocation, setCreateLocation] = useState<any>({});
  const { data: countries = [] } = useFetchCountriesAllData();

  const { data: timeSlotData, refetch: fetchTimeSlot } =
    useFetchDriverTimeSlotAllData();

  useEffect(() => {
    if (darkStoreData) {
      setValue("storeName", darkStoreData?.name);
      setValue("mobileNo", darkStoreData?.mobileNo);
      setValue("email", darkStoreData?.email);
      setValue("countryId", darkStoreData?.countryId);
      setValue("cityId", darkStoreData?.cityId);
      setValue("districtId", darkStoreData?.districtId);
      setValue("shortAddress", darkStoreData?.shortAddress);
      setValue("driverAssignment", darkStoreData?.driverAssignmentType);
      setValue("latitude", darkStoreData?.latitude);
      setValue("longitude", darkStoreData?.longitude);
      setValue("pinCode", darkStoreData?.pincode);
      setValue("fullAddress", darkStoreData?.fullAddress);
      setValue("contactPerson", darkStoreData?.contactPerson);
      setValue("photo", darkStoreData?.photo);
      // setValue("timeSlotId", darkStoreData?.timeSlotId);

      setCreateLocation((prev: any) => ({
        ...prev,
        country: {
          id: darkStoreData?.countryId,
          name: darkStoreData?.countryName,
        },
        city: {
          id: darkStoreData?.cityId,
          name: darkStoreData?.cityName,
        },
        district: {
          id: darkStoreData?.districtId,
          name: darkStoreData?.districtName,
        },
      }));
    }
  }, [darkStoreData]);

  const {
    data: cities = [],
    refetch: fetchReceiverCities,
    isFetching: isFetchingCities,
  } = useFetchCountryCitiesAllData(createLocation?.country?.id);

  const {
    data: districts = [],
    refetch: fetchReceiverDistricts,
    isFetching: isFetchingDistricts,
  } = useDistrictFetchData(createLocation?.city?.id);

  useEffect(() => {
    if (createLocation?.country?.id) {
      fetchReceiverCities();
    }
  }, [createLocation?.country?.id]);

  useEffect(() => {
    if (createLocation?.city?.id) {
      fetchReceiverDistricts();
    }
  }, [createLocation?.city?.id]);

  return (
    <div className="w-full space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]  ">
      <div className=" h-[calc(100vh-10rem)] overflow-y-auto space-y-4 pt-0 p-4 px-6 scrollbar-clean">
        <div className="grid grid-cols-6 gap-4">
          <p className="text-[#212121]/80 col-span-6 uppercase text-sm font-medium">
            DARK STORE INFORMATION
          </p>
          <div className="flex items-center space-x-4 col-span-6">
            {/* <Controller
              control={control}
              name="photo"
              rules={{
                validate: (file: File | string | undefined) => {
                  if (!file) return true;

                  const allowedTypes = [
                    "image/jpeg",
                    "image/png",
                    "image/jpg",
                    "application/pdf",
                  ];
                  const fileObj = file instanceof File ? file : null;

                  if (fileObj) {
                    if (!allowedTypes.includes(fileObj.type)) {
                      const ext = getFileExtension(fileObj);
                      if (!["jpeg", "png", "jpg", "pdf"].includes(ext)) {
                        return "Only JPG, JPEG, PNG, or PDF allowed";
                      }
                    }
                  }
                  return true;
                },
              }}
              render={({ field, fieldState }) => {
                const fileURL =
                  field.value instanceof File
                    ? URL.createObjectURL(field.value)
                    : typeof field.value === "string" && field.value !== ""
                      ? field.value
                      : "/img/dummy-logo.png";

                return (
                  <div className="flex items-center space-x-3 w-full">
                    <img
                      src={fileURL}
                      className="size-16 rounded-xl object-cover border-2 border-dashed border-gray-300"
                      alt="Company Logo"
                    />

                    <div className="space-y-1">
                      <div className="flex items-center gap-3">
                        <input
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          className="hidden"
                          id="imageUpload"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              field.onChange(file);
                              setSelectedDocument?.((prev: any) => ({
                                ...prev,
                                photo: true,
                              }));
                              clearErrors("photo");
                            }
                          }}
                        />
                        <label
                          htmlFor="imageUpload"
                          className="text-[#212121] cursor-pointer border rounded-lg text-sm px-4 py-1 border-[#FBD037] bg-[#FBD037]/20 hover:bg-[#FBD037]/30 transition"
                        >
                          Upload
                        </label>

                        {field.value && (
                          <button
                            type="button"
                            className="text-red-500 text-sm hover:underline"
                            onClick={() => {
                              field.onChange(undefined);
                              setSelectedDocument?.((prev: any) => ({
                                ...prev,
                                image: false,
                              }));
                            }}
                          >
                            Remove
                          </button>
                        )}
                      </div>

                      <p className="text-xs text-[#555]">
                        Accepted formats: PNG, JPG (Max file size: 1 MB)
                      </p>
                    </div>
                  </div>
                );
              }}
            /> */}
            <Controller
              control={control}
              name="photo"
              rules={{
                validate: (file: File | string | undefined) => {
                  if (!file) return true;

                  if (typeof file === "string") return true;

                  const MAX_SIZE = 1 * 1024 * 1024;
                  if (file.size > MAX_SIZE) {
                    return "File size must be 1 MB or less";
                  }

                  const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                  const fileObj = file instanceof File ? file : null;

                  if (fileObj) {
                    if (!allowedTypes.includes(fileObj.type)) {
                      const ext = getFileExtension(fileObj);
                      if (!["jpeg", "png", "jpg"].includes(ext)) {
                        return "Only JPG, JPEG, or PNG allowed";
                      }
                    }
                  }
                  return true;
                },
              }}
              render={({ field, fieldState }) => {
                const fileURL =
                  field.value instanceof File
                    ? URL.createObjectURL(field.value)
                    : typeof field.value === "string" && field.value !== ""
                      ? field.value
                      : "/img/dummy-logo.png";

                return (
                  <>
                    <img
                      src={fileURL}
                      className="size-16 rounded-xl object-cover border-2 border-dashed border-gray-300"
                      alt="Photo"
                    />

                    <div className="space-y-1">
                      <div className="flex items-center gap-3">
                        <input
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          className="hidden"
                          id="photo-upload"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              field.onChange(file);
                              setSelectedDocument?.((prev: any) => ({
                                ...prev,
                                photo: true,
                              }));
                              clearErrors("photo");
                            }
                          }}
                        />
                        <label
                          htmlFor="photo-upload"
                          className="text-[#212121] cursor-pointer border rounded-lg text-sm px-4 py-1 border-[#FBD037] bg-[#FBD037]/20 hover:bg-[#FBD037]/30 transition"
                        >
                          Upload
                        </label>

                        {field.value && (
                          <button
                            type="button"
                            className="text-red-500 text-sm hover:underline"
                            onClick={() => {
                              field.onChange(undefined);
                              setSelectedDocument?.((prev: any) => ({
                                ...prev,
                                photo: false,
                              }));
                            }}
                          >
                            Remove
                          </button>
                        )}
                      </div>

                      <p className="text-xs text-[#555]">
                        Accepted formats: PNG, JPG (Max file size: 1 MB)
                      </p>

                      {fieldState.error && (
                        <p className="text-red-500 text-xs font-medium mt-1">
                          {fieldState.error.message}
                        </p>
                      )}
                    </div>
                  </>
                );
              }}
            />
          </div>
          {watch("storeCode") && (
            <NewinputField
              className="col-span-2"
              name="storeCode"
              type="text"
              title="Store Code"
              placeholder="storeCode"
              register={register}
              disabled={true}
            />
          )}

          {!parentId && (
            <NewinputField
              labelClass="text-[#1E293B] text-sm"
              name="storeName"
              type="text"
              title="Store Name"
              className="col-span-2"
              placeholder=""
              register={register}
              error={errors?.storeName}
              validation={{
                required: "Store Name is required",
                validate: (value: string) => {
                  const trimmed = value.trim();
                  if (trimmed.length < 3)
                    return "Store Name must be at least 3 characters";
                  if (trimmed.length > 30)
                    return "Store Name must be at most 30 characters";
                  if (!value?.trim())
                    return "Store Name cannot be empty or only spaces";
                  if (!/^[A-Za-z]/.test(trimmed)) {
                    return "Store Name must start from a letter";
                  }
                  return true;
                },
                pattern: {
                  value: /^[A-Za-z][A-Za-z0-9\s-]*$/,
                  message:
                    "Store Name must be start from a letter (not from numbers)",
                },
              }}
            />
          )}

          <NewinputField
            labelClass="text-sm text-[#1E293B]"
            name="contactPerson"
            type="text"
            title="Contact Person"
            placeholder=""
            className="col-span-2"
            register={register}
            error={errors?.contactPerson}
            validation={{
              required: "Contact Person is required",
              validate: (value: string) => {
                const trimmed = value.trim();
                if (trimmed.length < 3)
                  return "Contact person must be at least 3 characters";
                if (trimmed.length > 30)
                  return "Contact person must be at most 30 characters";
                return true;
              },
            }}
          />

          <NewinputField
            labelClass="text-sm text-[#1E293B]"
            name="mobileNo"
            type="number"
            title="Mobile Number"
            placeholder=""
            register={register}
            className="col-span-2"
            error={errors?.mobileNo}
            validation={{
              required: "Mobile number is required",
              validate: (value: any) => {
                console.log(value, "value");
                if (value === undefined || value === null) {
                  return "Mobile number is required";
                }

                const trimmed = String(value).trim();
                if (trimmed.length < 9 || trimmed.length > 12) {
                  return "Mobile number must be between 9 and 12 digits";
                }

                if (!/^\d+$/.test(trimmed)) {
                  return "Mobile number must contain only digits";
                }
                return true;
              },
            }}
          />

          <NewinputField
            labelClass="text-sm text-[#1E293B]"
            name="email"
            type="text"
            title="Mail ID"
            placeholder=""
            className="col-span-2"
            register={register}
            error={errors?.email}
            validation={{
              required: "Email is required",
              setValueAs: (value: string) => value?.toLowerCase(),
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Please enter a valid email address",
              },
            }}
          />
          {/* <NewSelectInput
            className="col-span-2"
            name="timeSlotId"
            label="Preferred Time Slot"
            selectOptions={
              timeSlotData?.map((t: any) => ({
                id: t.id,
                value: t.id,
                text: t.slotName,
              })) || []
            }
            clearErrors={clearErrors}
            register={register}
            disabled={!timeSlotData || timeSlotData?.length === 0}
            value={watch("timeSlotId")}
            setValue={(val: string) => {
              setSelectedTimeSlot(val);
              setValue("timeSlotId", val);
            }}
          /> */}

          <NewSelectInput
            name="countryId"
            className="col-span-2"
            label="Country"
            placeholder="Select Country"
            selectOptions={countries.map((country: any) => ({
              id: country.id,
              value: country.id,
              text: country.name,
            }))}
            register={register}
            clearErrors={clearErrors}
            error={errors.countryId}
            validation={{ required: "country is required" }}
            value={watch("countryId")}
            setValue={(value: any) => {
              setCreateLocation((prev: any) => ({
                ...prev,
                country: {
                  id: value,
                  name: countries?.find((c: any) => c.id === value)?.name,
                },
                city: undefined,
                district: undefined,
              }));
              clearErrors("countryId");
              setValue("countryId", value);
            }}
          />
          <NewSelectInput
            name="cityId"
            className="col-span-2"
            label="City"
            placeholder={isFetchingCities ? "Loading cities..." : "Select City"}
            selectOptions={cities.map((city: any) => ({
              id: city.id,
              value: city.id,
              text: city.name,
            }))}
            register={register}
            clearErrors={clearErrors}
            validation={{ required: "city is required" }}
            error={errors.cityId}
            value={watch("cityId")}
            setValue={(value: any) => {
              setCreateLocation((prev: any) => ({
                ...prev,
                city: {
                  id: value,
                  name: cities.find((c: any) => c.id === value)?.name,
                },
                district: undefined,
              }));
              clearErrors("cityId");
              setValue("cityId", value);
            }}
          />
          <NewSelectInput
            name="districtId"
            className="col-span-2"
            label="District"
            placeholder={
              isFetchingDistricts ? "Loading districts..." : "Select District"
            }
            selectOptions={
              districts.map((district: any) => ({
                id: district.id,
                value: district.id,
                text: district.name,
              })) || []
            }
            register={register}
            clearErrors={clearErrors}
            error={errors.districtId}
            validation={{ required: "district is required" }}
            value={watch("districtId")}
            setValue={(value: any) => {
              setCreateLocation((prev: any) => ({
                ...prev,
                district: {
                  id: value,
                  name: districts.find((d: any) => d.id === value)?.name,
                },
              }));
              clearErrors("districtId");
              setValue("districtId", value);
            }}
          />
          <NewinputField
            className="col-span-2"
            name="pinCode"
            type="text"
            title="Pin Code"
            placeholder="Enter Pin Code"
            register={register}
            error={errors.pinCode}
            validation={{ required: "Pin Code is required" }}
          />

          <NewinputField
            className="col-span-2"
            name="latitude"
            type="text"
            title="Latitude"
            placeholder="Enter Latitude"
            register={register}
            error={errors.latitude}
            validation={{ required: "Latitude is required" }}
          />
          <NewinputField
            className="col-span-3"
            name="longitude"
            type="text"
            title="Longitude"
            placeholder="Enter longitude"
            register={register}
            error={errors.longitude}
            validation={{ required: "Longitude is required" }}
          />

          <NewinputField
            className="col-span-3"
            name="shortAddress"
            type="text"
            title="Short Address"
            placeholder="Enter Short Address"
            register={register}
            error={errors.shortAddress}
            validation={
              createLocation?.country?.name?.toLowerCase() === "saudi arabia"
                ? { required: "Short Address is required" }
                : undefined
            }
          />

          <NewinputField
            name="fullAddress"
            className="col-span-6"
            title="Full Address"
            placeholder="Enter Full Address"
            register={register}
            error={errors.fullAddress}
            validation={{ required: "Full Address is required" }}
          />
        </div>
      </div>
    </div>
  );
};

export default AddDarkStoreModal;
